define([
   'text!product-detail/component/dimension-table.html',
    'product-detail/mixin/product',
    'inView',

    'css!product-detail/component/dimension-table.css'
], function(
    tpl,
    ProductDetail,
    inView
){
    return {
        template: tpl,
        mixins: [ProductDetail],
        data: function(){
            return {
                isEnter: false,
                className: 'js-dimension-table'
            };
        },
        computed: {
            tableSpecData: function(){
                return this.spuExtraBase.tableSpecData || {};
            },
            tableList: function(){
                return this.tableSpecData.list || [];
            },
            tableSpecList: function(){
                return this.tableSpecData.specList || [];
            },
            selectedColId: function(){
                return this.selectedSkuExtra.tableSpecData || '';
            },
            isRender: function(){
                return this.moduleConfig.tableSpec && this.tableList.length && this.tableSpecList.length;
            }
        },
        mounted: function(){
            var _this = this;
            var task = null;
            var delayTime = 500;
            inView('.'+this.className).on('enter', function(){
                task = setTimeout(function(){
                    _this.isEnter = true;
                },delayTime);
            }).on('exit', function(){
                if (task){
                    clearTimeout(task);
                    task = null;
                }
                _this.isEnter = false;
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/dimension-table.js
// module id = 143
// module chunks = 0